export const ACQUISITION_TABLE_GET_ALL_SUCCESS = 'ACQUISITION_GET_ALL_SUCCESS';
export const ACQUISITION_TABLE_GET_ALL_FAILURE = 'ACQUISITION_GET_ALL_FAILURE';
export const ACQUISITION_TABLE_DATA_IS_LOADING = 'ACQUISITION_DATA_IS_LOADING';
